import React from "react";

const CompanyContext = React.createContext();

export default CompanyContext;
